"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormDraftIMSchema = exports.FormSaveDraftRequestSchema = exports.FormSubmitRequestSchema = exports.ConfirmAttachmentStateBodySchema = exports.RequestAttachmentUploadBodySchema = exports.FormAttachmentRecordSchema = exports.FormDraftRecordSchema = exports.FormSubmissionCreateSchema = exports.FormSubmissionRecordSchema = exports.FormDefinitionRecordSchema = void 0;
const zod_1 = require("zod");
const form_definition_1 = require("./form-definition");
exports.FormDefinitionRecordSchema = form_definition_1.FormDefinitionSchema.extend({
    id: zod_1.z.string(),
    publishedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    publishedBy: zod_1.z.string().nullable(),
    publishedByDisplayName: zod_1.z.string().nullable(),
    /** Commit-message-style note from the publisher describing the change. */
    notes: zod_1.z.string().nullable(),
    createdAt: zod_1.z.string().datetime({ offset: true }),
});
exports.FormSubmissionRecordSchema = zod_1.z.object({
    id: zod_1.z.string(),
    formSlug: zod_1.z.string(),
    formVersion: zod_1.z.number().int(),
    /**
     * 1-indexed per (formSlug + disclosureId). Service-computed. Present on
     * `getSubmissionsByDisclosure` and `submit` (when disclosureId present).
     * Absent on slug-wide listings — fall back to `formVersion`.
     */
    submissionVersion: zod_1.z.number().int().optional(),
    disclosureId: zod_1.z.string().nullable(),
    submitterUserId: zod_1.z.string().nullable(),
    submitterIp: zod_1.z.string().nullable(),
    userAgent: zod_1.z.string().nullable(),
    answers: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
    computedScores: form_definition_1.FormComputedScoresSchema,
    processedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    createdAt: zod_1.z.string().datetime({ offset: true }),
});
exports.FormSubmissionCreateSchema = exports.FormSubmissionRecordSchema.omit({
    id: true,
    submissionVersion: true,
    processedAt: true,
    createdAt: true,
});
exports.FormDraftRecordSchema = zod_1.z.object({
    id: zod_1.z.string(),
    formSlug: zod_1.z.string(),
    formVersion: zod_1.z.number().int(),
    disclosureId: zod_1.z.string(),
    lastEditorUserId: zod_1.z.string(),
    // Derived (not stored). Server resolves from `lastEditorUserId`.
    lastEditorDisplayName: zod_1.z.string().nullable(),
    answers: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
    revision: zod_1.z.number().int(),
    createdAt: zod_1.z.string().datetime({ offset: true }),
    updatedAt: zod_1.z.string().datetime({ offset: true }),
});
// ---------- Form attachment (uploaded file linked to a question) ----------
// `formDraftId` is the draft selecting it now (null once submitted/removed);
// `submissionIds` is the append-only set of submissions that have included it.
exports.FormAttachmentRecordSchema = zod_1.z.object({
    id: zod_1.z.string(),
    formDraftId: zod_1.z.string().nullable(),
    submissionIds: zod_1.z.array(zod_1.z.string()),
    questionId: zod_1.z.string(),
    storageObjectVersionId: zod_1.z.string(),
    accessId: zod_1.z.string(),
    originalFilename: zod_1.z.string(),
    mimeType: zod_1.z.string().nullable(),
    fileSizeBytes: zod_1.z.number().int().nullable(),
    uploadState: zod_1.z.enum(['PENDING', 'SUCCESS', 'FAILED']),
    uploadedByUserId: zod_1.z.string(),
    createdAt: zod_1.z.string().datetime({ offset: true }),
});
exports.RequestAttachmentUploadBodySchema = zod_1.z.object({
    disclosureId: zod_1.z.string(),
    questionId: zod_1.z.string(),
    originalFilename: zod_1.z.string(),
    mimeType: zod_1.z.string(),
    fileSizeBytes: zod_1.z.number().int().nonnegative(),
});
/** Body for confirming an attachment's upload outcome. The client only ever
 *  reports a terminal state — PENDING is server-set at creation, never sent. */
exports.ConfirmAttachmentStateBodySchema = zod_1.z.object({
    state: zod_1.z.enum(['SUCCESS', 'FAILED']),
});
// ---------- HTTP request bodies (the wire shape, validated at the boundary) ----------
// `answers` stays an open record: its real contract is the form-definition-
// driven schema from compileSubmissionSchema, applied downstream. These only
// validate the envelope around it.
exports.FormSubmitRequestSchema = zod_1.z.object({
    answers: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).default({}),
});
exports.FormSaveDraftRequestSchema = zod_1.z.object({
    disclosureId: zod_1.z.string().min(1),
    answers: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).default({}),
    /** Revision the client loaded; omit for the very first save (no row yet). */
    baseRevision: zod_1.z.number().int().optional(),
});
exports.FormDraftIMSchema = zod_1.z.object({
    formSlug: zod_1.z.string(),
    formVersion: zod_1.z.number().int(),
    disclosureId: zod_1.z.string(),
    lastEditorUserId: zod_1.z.string(),
    answers: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
    /** Revision client loaded. Undefined for first save (no row yet). */
    expectedRevision: zod_1.z.number().int().optional(),
});
